<template>
  <section v-if="content" class="page terms">
    <div class="terms__title">
      <AppTitle title="labor of fashion" size="little"/>
    </div>
    <div class="terms__blocs">

      <template v-for="(item, index) in content.acf.blocs">
        <div :key="index" class="container">
          <div class="terms__container">
            <h3 v-if="item.title_text.length" class="terms__baseline" v-html="item.title_text"></h3>
            <div v-if="item.paragraph_text.length" class="terms__description" v-html="item.paragraph_text"></div>
          </div>
        </div>
      </template>

    </div>
  </section>
</template>

<script>
  import Page from '@/mixins/Page'

  import AppTitle from '@/components/AppTitle.vue'

  export default {
    name: 'Terms',

    mixins: [
        Page
    ],

    components: {
      AppTitle
    },

    data() {
      return {

      }
    },

    created()
    {
      const endpoint = '/wp-json/acf/v3/pages/741'
      this.loadDatas(endpoint, (res) => {

        this.content = res
        this.onLoadedDatas()

      })
    }
  }
</script>

<style lang="stylus">
  .terms__blocs
    margin-bottom 200px

    @media(max-width 768px)
      margin-bottom 100px

  .terms__container
    width calc(100% / 36 * 20)
    margin 0 auto

    @media(max-width 768px)
      width 100%

  .terms__baseline, .terms__description
    padding 0 calc(100% / 20 * 2)

    @media(max-width 768px)
      padding 0 20px

  .terms__baseline
    // margin-top 150px
    // margin-bottom 70px
    text-align center
    font-size 42px
    line-height 0.9
    text-transform uppercase
    interpolate('margin-top', 768px, 2560px, 100px, 300px);
    interpolate('margin-bottom', 768px, 2560px, 50px, 150px);
    interpolate('font-size', 1600px, 2560px, 60px, 84px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 30px, 60px);

    @media(max-width 768px)
      margin-top 50px
      margin-bottom 50px
      font-size 28px

  .terms__description
    margin-bottom 30px
    font-size 20px
    line-height 1.5
    interpolate('margin-bottom', 768px, 2560px, 26px, 80px);
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 25px);

    a
      text-decoration underline

    u
      text-decoration underline
    
    i
      font-style italic 
    
    b
      font-weight 700

</style>